<template>
        <div class="service-thumb"
            ref="thumb"
            v-on:mouseover="mouseOver"
            v-on:mouseleave="mouseLeave"
            v-on:click="onClick(data.id)"
            v-bind:class="{'active':data.id == activeId, 'animate-in': animated}">

            <div class="bg" :style="styleObject.background"></div>
            <div class="overlay"></div>
            <div class="title">
                {{ data.title }}
            </div>
        </div>

</template>

<script>
import Service from "./Service.js";

export default {
  props: ["data", "activeId", "animated"],
  data() {
    return {
      Service: new Service(this.data)
    };
  },
  methods: {
    mouseOver: function() {},
    mouseLeave: function() {},
    onClick: function(serviceId) {
      this.$emit("switch", serviceId);
    },
    windowResize: function() {}
  },
  created() {},
  mounted() {},

  computed: {
    styleObject: function() {
      return this.Service.getStyleObject(this.data);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Services/Thumb.vue